export const isUserJurisdictions = (id, array) => array.find((x) => x.id === id);
